import { Link } from "react-router-dom";
import { SectionMeta } from "../components/SectionMeta.jsx";

const AUDIENCES = [
  {
    label: "For talent",
    title: "Do meaningful work with exceptional people.",
    body: "Pick projects that matter. Build with people you'd choose anyway. Get paid like it.",
    cta: "Apply to join",
    href: "/apply",
  },
  {
    label: "For companies",
    title: "Access agile, AI-powered creative & technology teams.",
    body: "Assemble a small, sharp team in days. Ship something you're actually proud of.",
    cta: "Brief the tribe",
    href: "mailto:partners@origamicreative.com",
  },
  {
    label: "For builders",
    title: "Find collaborators, opportunities, capital, momentum.",
    body: "If you're starting something — or restless to — the tribe is built for the leap.",
    cta: "Pitch your idea",
    href: "/apply",
  },
];

export function ForWho() {
  return (
    <section className="section shell" id="for-who">
      <SectionMeta num="§ 05" label="For who" right="Three doors. Same tribe." />

      <h2 className="h-large reveal section-head-spaced">
        Built for the <em>unconventional.</em>
      </h2>

      <div className="who-grid">
        {AUDIENCES.map((card) => (
          <article key={card.label} className="who-card reveal">
            <div>
              <span className="label">{card.label}</span>
              <h3>{card.title}</h3>
              <p className="who-body">{card.body}</p>
            </div>
            {card.href.startsWith("mailto:") ? (
              <a href={card.href} className="arrow-link">
                {card.cta}
              </a>
            ) : (
              <Link to={card.href} className="arrow-link">
                {card.cta}
              </Link>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}
